import { jsx as _jsx } from "react/jsx-runtime";
import { useIwaContext } from '@cognitranlimited/itis-web';
import React from 'react';
import logo from './brp-logo.svg';
import './BRPSmallLogo.css';
export var BRPSmallLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "BRPSmallLogo", src: logo, alt: strings.app.name });
};
